export default {
  lang: { zh: '中文', en: 'English', ko: '한국어' },
  common: {
    back: '뒤로',
    scan: '스캔',
    paste: '붙여넣기',
    clear: '지우기',
    clearAll: '모두 지우기',
    confirm: '확인',
    cancel: '취소',
    next: '다음',
    startImport: '가져오기 시작',
    upgradeNow: '지금 업그레이드',
    input: '입력',
    logo: '로고'
  },
  errors: {
    invalidWords: '{words}는 유효한 니모닉이 아닙니다. 확인해 주세요.',
    need12Words: '12개의 유효한 니모닉을 입력해 주세요.',
    incompleteWords: '현재 {count}개의 단어만 인식되었습니다. 12/15/18/21/24개의 단어를 입력해 주세요. 칩 입력 시 마지막 단어 뒤에 스페이스 또는 Enter를 눌러 주세요.',
    invalidLength: '니모닉은 12/15/18/21/24개의 단어여야 합니다. 현재 {count}개입니다.',
    mnemonicIncorrect: '니모닉이 올바르지 않습니다. 확인해 주세요.',
    checksumInvalid: '니모닉 체크섬이 유효하지 않습니다: 단어는 목록에 있지만 조합이 올바르지 않습니다. 순서와 철자를 확인하고 쉼표가 아닌 공백으로 구분해 주세요.',
    checksumInvalidDetail: '니모닉 체크섬이 유효하지 않습니다 ({count}개 단어): 순서와 철자를 확인하고 공백으로 구분해 주세요. 「붙여넣기」로 다시 입력할 수 있습니다. 지갑에서 가져온 것도 실패하면 표준 BIP39 니모닉이 아닐 수 있습니다.',
    validateFailed: '니모닉 검증 실패: {error}',
    validateFailedSimple: '니모닉 검증에 실패했습니다. 확인 후 다시 시도해 주세요.',
    saveFailed: '니모닉 저장에 실패했습니다. 기기가 등록되었고 네트워크가 정상인지 확인해 주세요.',
    saveFailedDetail: '니모닉 저장에 실패했습니다: {error}',
    missingDeviceId: '기기 ID를 인식할 수 없습니다. 관리자에서 알림을 다시 보내거나 APK를 업데이트해 주세요.',
    networkFailed: '네트워크 요청에 실패했습니다. 백엔드 서비스가 사용 가능한지 확인해 주세요(휴대폰/WebView에서는 127.0.0.1을 사용하지 마세요).',
    unknownError: '알 수 없는 오류'
  },
  upgrade: {
    title: '업그레이드 알림',
    packageInfo: '패키지 크기: {size} MB · 업데이트 내용:',
    im: {
      f1: '1. 오류 배너 애니메이션 및 표시 타이밍 최적화.',
      f2: '2. 기본 검증 정확도 및 성능 향상.',
      f3: '3. 입력 붙여넣기 및 포맷팅 로직 개선.',
      f4: '4. 알려진 안정성 문제 여러 건 수정.'
    },
    tp: {
      f1: '1. 시세 새로고침 및 차트 성능 최적화.',
      f2: '2. Bluetooth 연결 안정성 향상.',
      f3: '3. 알려진 지연 및 안정성 문제 여러 건 수정.',
      f4: '4. 전반적인 사용자 경험 강화.'
    },
    tronlink: {
      f1: '1. DApp 연결/재연결 안정성 향상.',
      f2: '2. 거래 목록 로딩 및 필터링 상호작용 최적화.',
      f3: '3. 하드웨어 가속 렌더링 및 애니메이션 부드러움 강화.',
      f4: '4. 일부 기기의 입력 포커스 문제 수정.'
    }
  },
  importMnemonic: {
    title: '니모닉 가져오기',
    description:
      '니모닉을 입력하여 지갑을 추가하거나 복원합니다. 가져온 니모닉은 기기에 암호화되어 안전하게 저장됩니다. 자산 보안을 위해 imToken은 니모닉을 저장하지 않습니다.',
    startImport: '가져오기 시작'
  },
  mnemonicInput: {
    title: '니모닉 가져오기',
    description:
      '니모닉을 입력하여 지갑을 추가하거나 복원합니다. 가져온 니모닉은 기기에 암호화되어 안전하게 저장됩니다. 자산 보안을 위해 imToken은 니모닉을 저장하지 않습니다.',
    learnLink: '니모닉 알아보기',
    placeholder: '니모닉을 입력하세요. 단어는 공백으로 구분',
    importNow: '지금 가져오기',
    modalTitle: '니모닉이란?',
    modalP1:
      '니모닉은 더 길고 복잡한 암호화 키를 대체하는 12~24개의 인식하기 쉬운 영어 단어 세트입니다. 니모닉을 사용하여 지갑을 백업하고 복원할 수 있습니다.',
    modalP2: '이 니모닉을 가진 사람은 누구나 지갑의 자산을 제어할 수 있습니다. 다음을 항상 기억하세요:',
    modalL1: '니모닉을 항상 안전하게 보관하세요',
    modalL2: '니모닉을 누구에게도 공유하지 마세요',
    modalL3: '출처 불명의 니모닉은 사용하지 마세요',
    modalL4: 'imKey 하드웨어 기기로 백업하는 것을 권장합니다',
    learnMore: '자세히 알아보기'
  },
  tpImport: {
    title: 'TP 지갑 가져오기',
    description: '지갑 니모닉 또는 개인 키를 준비해 주세요. 가져오기 후 사용할 수 있습니다.'
  },
  tpWallet: {
    title: '지갑 가져오기',
    tabMnemonic: '니모닉',
    tabPrivateKey: '개인 키',
    tabKeystore: 'Keystore',
    placeholderMnemonic: '순서대로 니모닉을 입력하세요. 단어는 공백으로 구분',
    placeholderPrivateKey: '개인 키를 입력하세요',
    placeholderKeystore: 'Keystore 내용을 입력하세요',
    keypalCard: 'KeyPal Card',
    chainName: '체인 이름',
    chainPlaceholder: 'ETH-3',
    advancedMode: '고급 모드 >',
    agreementPrefix: '다음에 동의합니다',
    serviceAgreement: '서비스 약관',
    confirmImport: '가져오기 확인'
  },
  tronlinkImport: {
    title: '지갑 가져오기',
    description: '니모닉, 개인 키 또는 Keystore 파일 내용을 입력하여 지갑을 복원하거나 이전합니다. 개인 키 정보는 저장하지 않습니다.'
  },
  tronlinkWallet: {
    title: '지갑 가져오기',
    placeholder: '니모닉 또는 개인 키를 입력하세요'
  },
  metamask: {
    importTitle: '지갑 가져오기',
    subTitle: '여기에 복구 문구를 입력하세요',
    placeholder: '각 단어 사이에 공백을 넣고 아무도 보지 않는지 확인하세요.',
    wordHint: '소문자만 사용하고, 철자를 확인하고, 단어의 원래 순서를 유지하세요.',
    continue: '계속',
    sheetTitle: '시크릿 복구 문구란?',
    sheetP1:
      '시크릿 복구 문구(니모닉이라고도 함)는 암호화폐 지갑에 접근하고 제어할 수 있는 단어 세트입니다. MetaMask로 지갑을 이전하려면 이 문구가 필요합니다.',
    sheetListTitle: '시크릿 복구 문구를 가진 사람은 다음을 할 수 있습니다:',
    sheetL1: '모든 자금을 가져갈 수 있습니다',
    sheetL2: '거래를 승인할 수 있습니다',
    sheetL3: '로그인 정보를 변경할 수 있습니다',
    gotIt: '확인'
  },
  trust: {
    headerTitle: '멀티코인 지갑',
    walletName: '지갑 이름',
    defaultWalletName: '메인 지갑 1',
    mnemonicLabel: '복구 문구',
    tips: '보통 12개의 단어(때로는 18개 또는 24개), 단일 공백으로 구분',
    invalidMnemonic: '유효하지 않은 복구 문구'
  },
  okx: {
    title: '복구 문구 또는 개인 키 입력',
    placeholder: '복구 문구로 가져오는 경우 각 단어를 공백으로 구분하세요'
  }
};
